import { useMantineTheme } from '@mantine/core';
import { useMemo } from 'react';
import type { TOAST_TYPE } from './types';

export default function useToastStyles(type: TOAST_TYPE) {
  const { colors } = useMantineTheme();

  return useMemo(() => {
    const styles = {
      success: {
        background: colors.green['10'],
        border: `1px solid rgba(154, 230, 180, 0.4)`,
        text: colors.green['50'],
        icon: colors.green['40'],
        // progressBar: colors.green['40'],
      },
      error: {
        background: colors.red['10'],
        border: '1px solid rgba(255, 163, 158, 0.4)',
        text: colors.red['50'],
        icon: colors.red['40'],
        // progressBar: colors.red['40'],
      },
      warning: {
        background: colors.yellow['10'],
        border: '1px solid rgba(255, 213, 145, 0.4)',
        text: colors.yellow['50'],
        icon: colors.yellow['40'],
        // progressBar: colors.yellow['40'],
      },
      info: {
        background: colors.neutral['7'],
        border: '1px solid rgba(145, 213, 255, 0.4)',
        text: 'white',
        icon: 'white',
        // progressBar: colors.blue['40'],
      },
      // primary: {
      //   background: color.primary['10'],
      //   border: '1px solid rgba(254, 95, 0, 0.3)',
      //   text: color.primary['50'],
      //   icon: color.primary['40'],
      //   progressBar: color.primary['40'],
      // },
      // secondary: {
      //   background: color.secondary['10'],
      //   border: '1px solid rgba(14, 65, 116, 0.3)',
      //   text: color.secondary['50'],
      //   icon: color.secondary['40'],
      //   progressBar: color.secondary['40'],
      // },
      // neutral: {
      //   background: color.neutral['10'],
      //   border: '1px solid rgba(203, 213, 225, 0.5)',
      //   text: color.neutral['50'],
      //   icon: color.neutral['40'],
      //   progressBar: color.neutral['40'],
      // },
    };

    return styles[type];
  }, [type]);
}
